/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {layout} from 'icsoc-antd-ex';
import {message} from 'antd';
import UnionComponent from 'Components/union/unionComponent';
import actions from 'Actions/taskManage/questionNaire';
import Search from './search';
import Bar from './bar';
import Pie from './pie';
import TableList from './tableList';
import ReloadModal from '../../systemSetting/exportTasks/modal/reloadModal';

import './index.less';

const {BaseContentMainHeader} = layout;
class List extends UnionComponent {
  constructor(props) {
    super(props);
    this.state = {
      reloadModalVisible: false, // 重新创建弹框是否可见
      pageType: 'questionNaire',
    };
  }

  // 设置重新创建弹框显示隐藏
  setReloadModalVisible = () => {
    const {reloadModalVisible} = this.state;
    this.setState({
      reloadModalVisible: !reloadModalVisible,
    });
  };

  // 导出
  exportTask = taskName => {
    const {searchData, actions, questionQueryReqs} = this.props;
    const parmas = {
      syncTaskName: taskName,
      startMillis: searchData.startMillis,
      endMillis: searchData.endMillis,
      taskId: searchData.taskId,
      questionQueryReqs,
    };
    actions.exportTask(parmas).then(res => {
      if (res.payload.code === 200) {
        message.success('创建导出任务成功！');
      }
    });
  };

  // 点击查询 更新表格头部
  topSearch = params => {
    const {actions} = this.props;
    actions.getTableHead({...params}).then(() => {
      // 调用子组件更新表头和列表方法
      this.TableList.getList();
    });
  };

  onRef = ref => {
    this.TableList = ref;
  };

  render() {
    const {pageType, reloadModalVisible} = this.state;
    return (
      <div className="questionNaire">
        <BaseContentMainHeader title="问卷统计" />
        <Search
          getTableList={this.getCustomizeTableList}
          topSearch={this.topSearch}
        />
        <div className="content">
          {/* <Pie />
          <Bar /> */}
          <TableList
            onRef={this.onRef}
            getTableList={this.getCustomizeTableList}
            setReloadModalVisible={this.setReloadModalVisible}
          />
        </div>
        {reloadModalVisible ? (
          <ReloadModal
            getTableList={this.getCustomizeTableList}
            setReloadModalVisible={this.setReloadModalVisible}
            pageType={pageType}
            exportTask={this.exportTask}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = ({taskManageQuestionNaire}) => ({
  searchData: taskManageQuestionNaire.searchData,
  questionQueryReqs: taskManageQuestionNaire.questionQueryReqs,
});

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(List);
